// ============================================================================
// equipment.fleet.index — migrated off the global read
// ============================================================================
// The /fleet list and its fuel-log view — one surface, because the fuel log is another view of the same loaded arrays rather than another mount.
//
// Four EquipmentHome surfaces share the single `equipment.fleet.core` resource because
// they are four renders of ONE container load, not four independent reads.
// That is still exactly one owner per surface: the catalog resource lists all
// four in its `surfaces` array, and the manifest/catalog/receipt equality
// carries the multiplicity as four distinct (surface, resource) pairs rather
// than collapsing them into one.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'equipment.fleet.index',
  obligations: Object.freeze([Object.freeze({id: 'equipment.fleet.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
